import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import Button from '../layout/button/Button';
import InputSelectCliente from './InputSelectCliente';

import AutenticarService from '../../service/AutenticarService';

class ModalSelectCliente extends  AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {            
            show: AutenticarService.getIdEmpresa() === 0,

            form: {
                id: 0,
                cnpj: '',
                nome: ''
            },

            erroForm: {
                id: ''               
            }
        }        
    }       

    onChange(empresa) {
        let form = this.state.form;

        form.id = empresa.id;
        form.cnpj = empresa.cnpj;
        form.nome = empresa.nome;
        
        this.setState({form: form});        
    }

    limparFormErro() {
        let erroForm = this.state.erroForm;

        erroForm.id = '';

        this.setState({erroForm: erroForm});
    }

    onClick() {
        this.limparFormErro();

        const form = this.state.form;
        let erroForm = this.state.erroForm;
        let erro = false;

        if(!form.id) {
            erroForm.id = 'Selecione a Empresa';
            erro = true;
        }

        if(erro) {
            this.setState({erroForm: erroForm});

            return ;
        }        
                
        this.props.updateEmpresa(form);

        this.setState({
            form: {
                id: 0,
                cnpj: '',
                nome: ''
            },
            show: false
        });
    }          

    showComponent() {        
        if((!this.state.show)&&(!this.props.modalSelectCliente))
            return ;

        return (
            <div 
                className="modal"
                tabIndex="-1" 
                role="dialog" 
                style={{display: 'block'}}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">                        
                        <div className="modal-header">
                            <div className="col-md-10                                 
                                            col-sm-10                                                
                                            col-lg-10                                                
                                            col-xs-10"> 
                                <h4>                                                                        
                                    Selecione a Empresa
                                </h4>
                            </div>

                            <div className="col-md-2                                 
                                            col-sm-2                                                
                                            col-lg-2                                                
                                            col-xs-2"> 
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>                        

                        <div className="modal-body">
                            <div                                 
                                style={{
                                    wordWrap: 'break-word', 
                                    marginBottom: '15px'
                                }}>
                                    
                                <InputSelectCliente
                                    clientes={this.props.clientes}
                                    form={this.state.form}
                                    erroForm={this.state.erroForm}
                                    usuario={this.props.usuario}
                                    
                                    updateEmpresa={(empresa) => this.props.updateEmpresa(empresa)}
                                    onChange={(empresa) => this.onChange(empresa)}
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <Button                                 
                                className="btn btn-primary"
                                type="button" 
                                onClick={() => this.onClick()}
                            >
                                Selecionar
                            </Button>

                            <Button                                 
                                className="btn btn-danger"
                                type="button" 
                                onClick={() => {this.setState({show: false}); this.props.onClose();}}
                            >
                                Cancelar
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <Fragment>
                {this.showComponent()}            
            </Fragment>
        )
    }
}

export default ModalSelectCliente;